// extracted by mini-css-extract-plugin
module.exports = {"upsell":"_3ROSMMLgJ-vpix0O9z0FsS","content":"_33woKVxEwBHv64xQYvnj7P","title":"_1kub_9wGZRGSaRZ9r8gWmK","subtitle":"IL6m1dmGT_pTrTbAGzFS6","button":"_19c138wo9WmBocfBAKLoH7"};